import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ViewerTax } from '../../../../../../core/models/api.models';
import {
  formatCurrency,
  formatNumber,
  formatPercentage,
  formatText,
  getTaxAdditionalFields
} from '../../investor-viewer-format.utils';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-viewer-tax-section',
  imports: [InvestorViewerAccordionComponent],
  templateUrl: './investor-viewer-tax-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../investor-viewer-section.shared.scss'
})
export class InvestorViewerTaxSectionComponent {
  readonly taxes = input.required<ViewerTax[]>();

  protected readonly formatText = formatText;
  protected readonly formatNumber = formatNumber;
  protected readonly formatCurrency = formatCurrency;
  protected readonly formatPercentage = formatPercentage;
  protected readonly getTaxAdditionalFields = getTaxAdditionalFields;
}
